import {
  Avatar, AvatarProps, ICON_CITY_VARIANT_OUTLINE,
} from '@doveit/bricks';
import React from 'react';

export type CompanyAvatarProps = Pick<AvatarProps, 'size' | 'aria-label'>;

export const CompanyAvatar: React.FC<CompanyAvatarProps> = (props) => (
  <Avatar
    {...props}
    placeholder={ICON_CITY_VARIANT_OUTLINE}
  />
);

export default CompanyAvatar;
